import CaseRetreival from "../../assets/img/home/case-retreival.png";
import  LiveMonitoring from "../../assets/img/home/live-monitoring.png";
import  GeoSpacial from "../../assets/img/home/geo-spacial.png";
import  CUBSUplaod from "../../assets/img/home/CUBS-Upload.png";
import  CUBSBANDownload from "../../assets/img/home/CUBS-Ban-Download.png";

import {
    CUBSCLRBANRD, CUBSCLRUPLDRD, CUBSCLRUPLDWT,
    DSLCRRD,
    DSLCRWT,
    DSLDASHRD,
    DSLDASHWT, DSLGEOUPLRD,
    DSLGEOUPLWT
} from "../../constants/accessconstants";
import {
    getCaseRetrivalLink,
    getCLRUploadLink,
    getDashboardLink,
    getLayerUploadLink
} from "../../constants/routeconstants";
import AppDialog from "../../components/dialog/appdialog";
import BANDownload from "../../components/bandownlaod/bandownload";
import React from "react";
import FileDownloadGrid from "./filedownloadgrid";
import {store} from "@app/common/store/store";
import {startDownload} from "@app/common/store/action";

export const appList=[
    {
        permission:`${DSLDASHRD},${DSLDASHWT}`,
        appDetails:{
            id:1,
            title:"Live Monitoring",
            link:getDashboardLink,
            img:LiveMonitoring
        }
    },
    {
        permission:`${DSLGEOUPLRD},${DSLGEOUPLWT}`,
        appDetails:{
            id:2,
            title:"Geospatial Repository",
            link:getLayerUploadLink,
            img:GeoSpacial
        }
    },
    {
        permission:`${DSLCRRD},${DSLCRWT}`,
        appDetails:{
            id:3,
            title:"Case Retrieval",
            link:getCaseRetrivalLink,
            img:CaseRetreival
        }
    },
    // {
    //     permission:`${CUBSCLRBANRD}`,
    //     appDetails:{
    //         id:4,
    //         title:"CLR BanFile Download",
    //         customFunc:()=>{
    //             let canDownload = store.getState().download;
    //             console.log("canDownload",canDownload)
    //             store.dispatch(startDownload(!canDownload))},
    //         img:CUBSBANDownload
    //     }
    // },
    {
        permission:`${CUBSCLRUPLDRD},${CUBSCLRUPLDWT}`,
        appDetails:{
            id:5,
            title:"CUBS CLR Upload",
            link:getCLRUploadLink,
            img:CUBSUplaod
        }
    }
]